
import Vue from "vue";
import AppFixedAssetEditCard from "@/components/bookkeeping/FixedAssetEditCard.vue";
import { ToolbarService } from "@/services/toolbar-service";
import { checkHasModule } from "@/router";
import { MODULE } from "@/config/modules";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	computed: {
		title():TranslateResult {
			return ToolbarService.title;
		}
	},
	methods: {
		async onCancel() {
			await this.$router.push("/fixed-assets");
		},
		async onRefresh() {
			this.$emit("refresh");
			await this.$router.push("/fixed-assets");
		}
	},
	mounted() {
		let id = parseInt(this.$route.params.id);
		ToolbarService.title = this.$ct(id ? "edit" : "new");
	},
	created() {
		if (!checkHasModule(MODULE.AFSCHRIJVINGSTABELLEN, this.$router)) {
			throw new Error("MISSING MODULE");
		}
	},
	components: {
		AppFixedAssetEditCard
	},
	i18nEx: {
		componentPrefix: "components.fixed-assets"
	}
});
